module.exports = __webpack_public_path__ + "static/media/mmsys_111.8236e87d.ico";